import { useState } from "react";
import {
  Users,
  UserPlus,
  UserRoundCheck,
  UserRoundX,
  Search,
  Filter,
  ArrowUpDown,
  ChevronDown,
  Download,
} from "lucide-react";
import MainLayout from "../sidebar/Sidebar.js";

const DesignReplicaDesktop = () => {
  const [location, setLocation] = useState("DesignReplica");
  const [searchTerm, setSearchTerm] = useState("");

  const leads = [
    {
      id: 1,
      name: "Rachel Scott",
      email: "rachel.scott@orbitsoft.com",
      phone: "+1-202-555-0143",
      channel: "Email",
      assignedTo: "Kevin",
      status: "Contacted",
      created: "Jul 03, 2025",
    },
    {
      id: 2,
      name: "Daniel Kim",
      email: "daniel.kim@cloudmerge.io",
      phone: "+1-202-555-0199",
      channel: "LinkedIn",
      assignedTo: "Unassigned",
      status: "New",
      created: "Jul 08, 2025",
    },
    {
      id: 3,
      name: "Lina Alvarez",
      email: "lina.alvarez@neotech.ai",
      phone: "+1-202-555-0187",
      channel: "Phone",
      assignedTo: "Nathanael",
      status: "Qualified",
      created: "Jul 01, 2025",
    },
    {
      id: 4,
      name: "Ben Foster",
      email: "ben.foster@blueline.co",
      phone: "+1-202-555-0123",
      channel: "Email",
      assignedTo: "Jordan",
      status: "Lost",
      created: "Jun 27, 2025",
    },
    {
      id: 5,
      name: "Jenna Malik",
      email: "jenna.malik@kanvas.io",
      phone: "+1-202-555-0174",
      channel: "Phone",
      assignedTo: "Kevin",
      status: "Qualified",
      created: "Jul 02, 2025",
    },
    {
      id: 6,
      name: "Ahmed Farouk",
      email: "ahmed.far@venturenow.com",
      phone: "+1-202-555-0168",
      channel: "Email",
      assignedTo: "Sophie",
      status: "Contacted",
      created: "Jul 03, 2025",
    },
    {
      id: 7,
      name: "Sophie Chan",
      email: "sophie.chan@novadesk.io",
      phone: "+1-202-555-0155",
      channel: "LinkedIn",
      assignedTo: "Unassigned",
      status: "New",
      created: "Jul 12, 2025",
    },
    {
      id: 8,
      name: "Marco Liu",
      email: "marco.liu@synera.ai",
      phone: "+1-202-555-0149",
      channel: "Phone",
      assignedTo: "Kevin",
      status: "Qualified",
      created: "Jul 10, 2025",
    },
    {
      id: 9,
      name: "Fatima Rahman",
      email: "fatima.rahman@bizworks.co",
      phone: "+1-202-555-0138",
      channel: "Email",
      assignedTo: "Jordan",
      status: "Lost",
      created: "Jun 05, 2025",
    },
    {
      id: 10,
      name: "Oliver Grant",
      email: "oliver.grant@sparkhive.com",
      phone: "+1-202-555-0110",
      channel: "LinkedIn",
      assignedTo: "Nathanael",
      status: "Qualified",
      created: "Jun 03, 2025",
    },
  ];

  const getStatusBadge = (status) => {
    const statusStyles = {
      Contacted: "bg-blue-100 text-blue-800 border border-blue-200",
      New: "bg-gray-100 text-gray-800 border border-gray-200",
      Qualified: "bg-green-100 text-green-800 border border-green-200",
      Lost: "bg-purple-100 text-purple-800 border border-purple-200",
    };

    return (
      <span
        className={`px-2 py-1 rounded-full text-xs font-medium ${statusStyles[status]}`}
      >
        {status}
      </span>
    );
  };

  return (
    <MainLayout location={location} setLocation={setLocation}>
      <div className="bg-gray-50">
        {/* Metrics Cards */}
        <div className="grid grid-cols-4 gap-4 mb-6">
          {/* Total Leads */}
          <div className="bg-white p-4 rounded-lg border border-gray-200">
            <div className="flex items-center gap-3 mb-3">
              <div className="p-2 bg-gray-100 rounded-lg">
                <Users className="w-5 h-5 text-gray-600" />
              </div>
              <span className="text-sm">Total Leads</span>
            </div>
            <div className="text-3xl font-light text-gray-900">82</div>
            <div className="text-sm text-gray-500">+4 vs last week</div>
          </div>

          {/* New Leads */}
          <div className="bg-white p-4 rounded-lg border border-gray-200">
            <div className="flex items-center gap-3 mb-3">
              <div className="p-2 bg-gray-100 rounded-lg">
                <UserPlus className="w-5 h-5 text-gray-600" />
              </div>
              <span className="text-sm">New Leads</span>
            </div>
            <div className="text-3xl font-light text-gray-900">18</div>
            <div className="text-sm text-gray-500">+2 vs last week</div>
          </div>

          {/* Qualified Leads */}
          <div className="bg-white p-4 rounded-lg border border-gray-200">
            <div className="flex items-center gap-3 mb-3">
              <div className="p-2 bg-gray-100 rounded-lg">
                <UserRoundCheck className="w-5 h-5 text-gray-600" />
              </div>
              <span className="text-sm">Qualified Leads</span>
            </div>
            <div className="text-3xl font-light text-gray-900">27</div>
            <div className="text-sm text-gray-500">32% of total leads</div>
          </div>

          {/* Lost Leads */}
          <div className="bg-white p-4 rounded-lg border border-gray-200">
            <div className="flex items-center gap-3 mb-3">
              <div className="p-2 bg-gray-100 rounded-lg">
                <UserRoundX className="w-5 h-5 text-gray-600" />
              </div>
              <span className="text-sm">Lost Leads</span>
            </div>
            <div className="text-3xl font-light text-gray-900">9</div>
            <div className="text-sm text-gray-500">-2 vs last week</div>
          </div>
        </div>

        {/* Table Section */}
        <div className="bg-white rounded-lg border border-gray-200">
          {/* Table Header */}
          <div className="flex items-center justify-between gap-3 p-4 border-b border-gray-200">
            <div className="flex items-center gap-3">
              {/* Search */}
              <div className="relative min-w-[200px]">
                <Search className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search here..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md bg-white text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Sort + Filter */}
              <div className="flex gap-2">
                <button className="flex items-center px-3 py-2 border border-gray-300 rounded-md bg-white text-sm shadow-sm hover:bg-gray-50">
                  <ArrowUpDown className="w-4 h-4 mr-1.5 text-gray-600" />
                  <span>Sort</span>
                  <ChevronDown className="w-4 h-4 text-gray-600 ml-1" />
                </button>
                <button className="flex items-center px-3 py-2 border border-gray-300 rounded-md bg-white text-sm shadow-sm hover:bg-gray-50">
                  <Filter className="w-4 h-4 mr-1.5 text-gray-600" />
                  <span>Filter</span>
                  <ChevronDown className="w-4 h-4 text-gray-600 ml-1" />
                </button>
              </div>
            </div>

            {/* Right Side Actions */}
            <div className="flex gap-2">
              <button className="flex items-center gap-1 px-3 py-2 border border-gray-300 rounded-md bg-white text-sm shadow-sm hover:bg-gray-50">
                <UserPlus className="w-4 h-4 text-gray-600" />
                Add Customer
              </button>
              <button className="flex items-center gap-1 px-3 py-2 border border-gray-300 rounded-md bg-white text-sm shadow-sm hover:bg-gray-50">
                <Download className="w-4 h-4 text-gray-600" />
                Export CSV
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    #
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Lead
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Phone
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Channel
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Assigned To
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Created
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {leads.map((lead) => (
                  <tr key={lead.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-900">
                      {lead.id}
                    </td>
                    <td className="px-4 py-3">
                      <div>
                        <div className="text-sm text-gray-900">{lead.name}</div>
                        <div className="text-sm text-gray-500">
                          {lead.email}
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900">
                      {lead.phone}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900">
                      {lead.channel}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900">
                      {lead.assignedTo}
                    </td>
                    <td className="px-4 py-3">{getStatusBadge(lead.status)}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">
                      {lead.created}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default DesignReplicaDesktop;
